import React from "react";
import { motion } from "framer-motion";

export default function About() {
  return (
    <section id="ueber-mich" className="relative py-24 sm:py-32 bg-[#FDFBF7]" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          {/* Image stack */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-5 relative"
          >
            <div className="absolute -top-6 -left-6 w-full h-full rounded-[2rem] bg-[#EBE3D5] -z-10" />
            <img
              src="https://customer-assets.emergentagent.com/job_postpartum-care-7/artifacts/d6u2idcm_1000100841.jpg"
              alt="Michele Galliker"
              className="w-full h-[520px] object-cover rounded-[2rem] shadow-sm"
            />
            <div className="absolute -bottom-6 -right-6 bg-[#FDFBF7] rounded-[1.5rem] p-5 shadow-sm border border-[#5C6B5E]/10 max-w-[220px]">
              <p className="font-display text-2xl text-[#2A332C] leading-tight">10 Jahre</p>
              <p className="text-xs text-[#5C6B5E] mt-1">Wochenbett-Erfahrung</p>
            </div>
          </motion.div>

          {/* Text */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, delay: 0.15 }}
            className="lg:col-span-7"
          >
            <p className="eyebrow mb-6">Über mich</p>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#2A332C] leading-[1.05] mb-8">
              Hallo, ich bin <span className="font-display-italic text-[#A66B56]">Michele</span>.
            </h2>
            <div className="space-y-5 text-[#5C6B5E] text-lg leading-relaxed">
              <p>
                Ich bin <strong className="text-[#2A332C] font-medium">Michele Galliker</strong> und lebe gemeinsam mit meinem Partner in Neuenkirch. Aufgewachsen bin ich auf einem Bauernhof in Römerswil.
              </p>
              <p>
                Meine berufliche Laufbahn begann mit der Ausbildung zur Fachfrau Gesundheit, gefolgt vom Diplom zur diplomierten Pflegefachfrau. Seither begleite ich mit viel Freude, Empathie und grosser Leidenschaft frischgebackene Eltern und ihre kleinen Wunder in einer ganz besonderen Lebensphase.
              </p>
              <p>
                Neben meiner freiberuflichen Tätigkeit in der ambulanten Wochenbettbetreuung bin ich im <strong className="text-[#2A332C] font-medium">Spital Sursee</strong> auf der Wochenbettstation tätig. Dadurch bleibe ich fachlich stets auf dem neuesten Stand und habe Zugang zu einem wertvollen Netzwerk aus Fachpersonen wie Kinderärzt:innen und Stillberater:innen.
              </p>
              <p>
                Es ist mir ein grosses Anliegen, dich und deine Familie einfühlsam, kompetent und individuell zu begleiten – damit ihr euch in eurem neuen Alltag sicher und gut aufgehoben fühlt.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
